<div class="card">
  <app-header
    [titulo]="'Conexões do Provedor: ' + (provedor?.nome || '')"
    descricao="Configure os endereços e as credenciais de cada ambiente deste provedor">
  </app-header>

  <div class="surface-50 border-1 surface-border border-round p-3 mb-4 line-height-3">
    Cada conexão representa um ambiente, como produção ou homologação. Os comandos do processo escolhem qual conexão usar.
    <span *ngIf="provedor?.tipo === TipoProvedor.APIREST">Depois de criar a conexão, abra <strong>Rotas da API</strong> para cadastrar os endereços que ela pode chamar.</span>
  </div>

  <p-toolbar styleClass="mb-4">
    <ng-template pTemplate="left">
      <p-button
        label="Nova Conexão"
        icon="pi pi-plus"
        severity="success"
        [disabled]="!provedor"
        (onClick)="novaConexao()">
      </p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <p-button label="Voltar" icon="pi pi-arrow-left" severity="secondary" (onClick)="voltar()"></p-button>
    </ng-template>
  </p-toolbar>

  <p-table [value]="conexoes" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="nome">Nome <p-sortIcon field="nome"></p-sortIcon></th>
        <th pSortableColumn="ambiente">Ambiente <p-sortIcon field="ambiente"></p-sortIcon></th>
        <th>URL Base / Host</th>
        <th>Credencial</th>
        <th pSortableColumn="padrao">Padrão <p-sortIcon field="padrao"></p-sortIcon></th>
        <th pSortableColumn="ativo">Status <p-sortIcon field="ativo"></p-sortIcon></th>
        <th style="width: 13rem">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-conexao>
      <tr>
        <td><strong>{{ conexao.nome }}</strong></td>
        <td>{{ conexao.ambiente }}</td>
        <td>{{ urlOuHost(conexao) }}</td>
        <td>
          <p-tag
            [value]="rotuloCredencialLista(conexao)"
            [severity]="credencialSuspeita(conexao) ? 'warning' : 'secondary'"
            [pTooltip]="credencialSuspeita(conexao) ? 'Conexões de banco precisam de usuário e senha para executar' : ''"
            tooltipPosition="top">
          </p-tag>
        </td>
        <td>
          <p-tag [value]="conexao.padrao ? 'Sim' : 'Não'" [severity]="conexao.padrao ? 'info' : 'secondary'"></p-tag>
        </td>
        <td>
          <p-tag [value]="conexao.ativo ? 'Ativo' : 'Inativo'" [severity]="conexao.ativo ? 'success' : 'danger'"></p-tag>
        </td>
        <td>
          <button *ngIf="provedor?.tipo === TipoProvedor.APIREST" pButton pRipple icon="pi pi-sitemap" label="Rotas da API" class="p-button-help p-button-text" [attr.aria-label]="'Configurar rotas de ' + conexao.nome" (click)="irParaEndpoints(conexao)"></button>
          <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-button-text" pTooltip="Editar" [attr.aria-label]="'Editar ' + conexao.nome" tooltipPosition="top" (click)="editarConexao(conexao)"></button>
          <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger p-button-text" pTooltip="Excluir" [attr.aria-label]="'Excluir ' + conexao.nome" tooltipPosition="top" (click)="deletarConexao(conexao)"></button>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center p-4">Nenhuma conexão cadastrada. Use <strong>Nova Conexão</strong> para informar o endereço e a credencial.</td>
      </tr>
    </ng-template>
  </p-table>
</div>

<!-- Dialog de Adicionar/Editar Conexão -->
<p-dialog
  [(visible)]="conexaoDialog"
  [style]="{width: '820px'}"
  [breakpoints]="{'960px': '90vw', '640px': '96vw'}"
  [contentStyle]="{'max-height': '70vh'}"
  [header]="isEditDialog ? 'Editar Conexão' : 'Nova Conexão'"
  [modal]="true"
  [draggable]="false"
  [resizable]="false">
  <ng-template pTemplate="content">
    <app-conexao-campos
      *ngIf="provedor"
      [form]="form"
      [tipoProvedor]="provedor.tipo"
      [modoEdicao]="isEditDialog"
      [tipoCredencialAtual]="conexaoEmEdicao?.tipoCredencial ?? null">
    </app-conexao-campos>
  </ng-template>

  <ng-template pTemplate="footer">
    <button pButton pRipple label="Cancelar" icon="pi pi-times" class="p-button-text" [disabled]="salvando" (click)="fecharDialog()"></button>
    <button pButton pRipple label="Salvar" icon="pi pi-check" class="p-button-success" [loading]="salvando" (click)="salvarConexao()"></button>
  </ng-template>
</p-dialog>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>
